<template>
  <v-footer
    height="auto"
    role="contentinfo"
  >
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <div v-once class="grey--text">
            <ul class="list--inline">
              <li><a :href="$options.siteUrls.doxoUrl">doxo.com</a></li>
              <li class="hidden-xs"><a :href="$options.siteUrls.aboutDoxoPath" id="ela_footer_about">About the doxo Network</a></li>
              <li class="hidden-xs"><a :href="$options.siteUrls.doxoForBusinessPath" id="ela_footer_business">doxo for business</a></li>
              <li><a :href="$options.siteUrls.privacyPolicyPath" id="ela_footer_security" v-external>Privacy Policy</a></li>
              <li><a :href="$options.siteUrls.fraudPreventionPath" id="ela_footer_fraud" v-external>Preventing fraud with doxo</a></li>
            </ul>
            <ul class="list--inline footer__app">
              <li>Get the app:&nbsp;</li>
              <li><v-icon small>phone_iphone</v-icon> <a :href="$options.siteUrls.iosAppUrl" id="ela_footer_ios" v-external>iPhone</a></li>
              <li><v-icon small>android</v-icon>
                <a
                :href="$options.siteUrls.androidAppUrl"
                class="icon-android"
                id="ela_footer_android"
                v-external
                >Android</a>
              </li>
            </ul>
            <div class="footer__data-consent">
              To improve user experience, doxo uses cookies that track certain user activity.<br>
              Visit doxo's <a :href="$options.siteUrls.dataTrackingUrl" target="_blank">Privacy Policy</a> to view details and access settings.
            </div>
            <div class="footer__copyright">
              &copy;{{ $options.year }} doxo, inc.
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  import footerMixin from '@/mixins/footer'

  export default {
    mixins: [footerMixin]
  }
</script>

<style scoped>
.footer__data-consent, .footer__copyright {
  color: #333333 !important;
}

.footer__data-consent {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// frontend/src/components/core/AppFooter.vue